import * as React from "react"
import styled from "styled-components"
import Subscribe from "./subscribe/Subscribe"
import LinkColumn from "./link-column/LinkColumn"
import PartnerBadges from "./partner-badges/PartnerBadges"
import { borderGrey } from "../../constants/colors"
import { FooterType } from "../../model/FooterType"
import { tablet } from "../../constants/screenSizes"
import ReviewsIoCarousel from "../../../components/home/reviews-io/ReviewsIoCarousel"

const StyledFooter = styled.footer`
  width: 100%;
  border-top: 1px solid ${borderGrey};
`

const LinksContainer = styled.div`
  display: flex;
  width: 100%;
  max-width: 1200px;
  margin: auto;
  padding-top: 40px;

  @media (max-width: ${tablet}px) {
    flex-direction: column;
  }
`

interface Props {
  footerData: FooterType
}

const Footer = ({ footerData }: Props) => {
  const { badges, infoItems, shopItems, socialItems } = footerData

  return (
    <StyledFooter>
      <ReviewsIoCarousel />
      <Subscribe />
      <LinksContainer>
        <LinkColumn title="Discover More" items={infoItems} />
        <LinkColumn title="Follow Us" items={socialItems} />
      </LinksContainer>
      <PartnerBadges badges={badges} />
    </StyledFooter>
  )
}

export default Footer
